import React from 'react';

import { Box, Heading, ButtonPrimary, Text } from '@primer/components'


export default function (props) {

  return (
    <Box className="container-lg pb-md-8 pl-4 pr-4 pt-8 pl-md-0 pr-md-0 pt-md-6">
      <Text as="p" className="f3">Django Doctor comes with two commands: "<a href="#fix"><code style={{fontSize: 'inherit'}}>Fix</code></a>" to suggest code improvements during development and "<a href="#check"><code style={{fontSize: 'inherit'}}>check</code>"</a> to use on CI servers or as a pre-commit hook to prevent Django anti-patterns being merged.</Text>

      <Heading id="fix" as="pre" className="mb-8 mt-8">$ django_doctor fix</Heading>
      <Text as="p" className="f3">1. Django Doctor analyses your codebase and opens the suggestion engine in your browser:</Text>
      
      <div className="mt-8 mb-8 position-relative text-center">
        <img src="/printscreen_commandline_fix_one.png" alt="A print screen" />
      </div>
      
      <Text as="p" className="f3">2. You accept or reject the suggestions:</Text>

      <div className="mt-8 mb-8 position-relative text-center">
        <img src="/printscreen_commandline_fix_two.png" alt="A print screen" />
      </div>

      <Text as="p" className="f3">3. The accepted suggestions are then saved to your file system:</Text>

      <div className="mt-8 position-relative text-center">
        <img src="/printscreen_commandline_check_end.png" alt="A print screen" />
      </div>

      <Heading id="check" as="pre" className="mb-8 mt-8">$ django_doctor check</Heading>
      <Text as="p" className="f3">1. Django Doctor shows the suggestions in your terminal:</Text>
      
      <div className="mt-8 mb-8 position-relative text-center">
        <img src="/printscreen_commandline_check.png" alt="A print screen" />
      </div>

      <Text as="p" className="f3">2. Django Doctor returns non-zero response (failing the build) if anti-patterns are detected.</Text>

      <Box alignItems="center" className="container-lg md-4 mt-4 mt-md-8 text-center">
        <a href="#price"><ButtonPrimary fontSize={4} className="pl-4 pr-4 pt-3 pb-3">Get Django Doctor</ButtonPrimary></a>
      </Box>

    </Box>
  )

}
